<div
  class="text-body-secondary d-sm-flex justify-content-between align-items-center mb-3"
  style="width: 100%">
  <div class="filter-bar d-flex flex-wrap flex-row align-items-center mt-1">
    <span class="filters-label">Applied Filters:</span>&nbsp; &nbsp;

    <!-- (click)="removeAuthor(author)" -->

    <!-- *ngIf="author['name']"  -->

    <ng-container *ngIf="searchFilters?.title && searchFilters?.title != ''">
      <div class="badge badge-item">
        <span class="fw-800"><i class="bi bi-search p-1"></i>Keyword: </span>
        <span>{{ searchFilters.title }}</span>
        <i class="bi bi-x p-1 ms-1" (click)="removeKeywordFilter()"></i>
      </div>
    </ng-container>

    <ng-container
      *ngIf="searchFilters?.school_year && searchFilters?.school_year != ''">
      <div class="badge badge-item">
        <span class="fw-800"
          ><i class="bi bi-calendar p-1"></i>School Year:
        </span>
        <span>{{ searchFilters.school_year }}</span>
        <i class="bi bi-x p-1 ms-1" (click)="removeSchoolYearFilter()"></i>
      </div>
    </ng-container>
  </div>
</div>
